import { render, staticRenderFns } from "./TextStriked.vue?vue&type=template&id=190cdd7d&scoped=true&"
import script from "./TextStriked.vue?vue&type=script&lang=js&"
export * from "./TextStriked.vue?vue&type=script&lang=js&"
import style0 from "./TextStriked.vue?vue&type=style&index=0&id=190cdd7d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190cdd7d",
  null
  
)

export default component.exports